import { render, staticRenderFns } from "./KitchenOrderPayment.vue?vue&type=template&id=b20e4e14&"
import script from "./KitchenOrderPayment.vue?vue&type=script&lang=js&"
export * from "./KitchenOrderPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports